import { render } from "./preFetch.vue?vue&type=template&id=3d3becb2"
import script from "./preFetch.vue?vue&type=script&lang=js"
export * from "./preFetch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__